var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-toaster" },
    _vm._l(_vm.messages, function(message) {
      return _c(message.component, {
        key: message.id,
        tag: "component",
        attrs: { message: message }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }